import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosInstance";


interface UsageData {
    count: number;
    plan: string;
    total_chats: number;
    error_rate: number;
    busiest_hour: string;
    is_trial_active?: boolean;
    trial_ends_in_days?: number;
    trial_end_date?: string;
    is_payment_valid: boolean;
    is_demo?: boolean;
    chat_count: number;
    limit?: number;
}

export default function Dashboard() {
    const restaurant_name = localStorage.getItem("restaurant_name");
    const navigate = useNavigate();
    const [usedRequests, setUsedRequests] = useState(0);
    const [subscriptionPlan, setSubscriptionPlan] = useState<string>("");
    const [totalChats, setTotalChats] = useState(0);
    const [errorRate, setErrorRate] = useState(0);
    const [busiestHour, setBusiestHour] = useState("--");

    // const remainingRequests = MAX_REQUESTS - usedRequests;
    // const usagePercent = Math.min((usedRequests / MAX_REQUESTS) * 100, 100);
    // const [usedRequests, setUsedRequests] = useState(0);
    const [chatCount, setChatCount] = useState(0);
    // const MAX_REQUESTS = 100;
    // const remainingRequests = MAX_REQUESTS - chatCount;
    // const usagePercent = Math.min((chatCount / MAX_REQUESTS) * 100, 100);
    // const MAX_REQUESTS = 300; // ⬅️ Updated limit
    // const remainingRequests = MAX_REQUESTS - chatCount;
    // const usagePercent = Math.min((chatCount / MAX_REQUESTS) * 100, 100);
    const [maxRequests, setMaxRequests] = useState<number>(300); // default fallback
    const remainingRequests = maxRequests - chatCount;
    const usagePercent = Math.min((chatCount / maxRequests) * 100, 100);




    const [isTrialActive, setIsTrialActive] = useState(false);
    const [trialEndsInDays, setTrialEndsInDays] = useState<number | null>(null);
    const [isPaymentValid, setIsPaymentValid] = useState(true); // default to true

    const [paymentWarningShown, setPaymentWarningShown] = useState(false); // NEW

    useEffect(() => {
        const fetchUsage = async () => {
            try {
                const res = await axios.get<UsageData>("/bot/request-usage");

                const isDemo = res.data.is_demo || false; // 👈 Extract
                const isPaymentOk = res.data.is_payment_valid || isDemo; // 👈 Allow demo access


                setIsPaymentValid(isPaymentOk);
                if (!isPaymentOk) {
                    setPaymentWarningShown(true);
                    return;
                }

                // setUsedRequests(res.data.count);
                setChatCount(res.data.chat_count || 0);
                setSubscriptionPlan(res.data.plan || "");
                // console.log("monthly limit: ",res.data.limit)
                if (res.data.limit) setMaxRequests(res.data.limit);
                // ... other usage setters
            } catch (err) {
                console.error("Failed to fetch request usage:", err);
            }
        };
        fetchUsage();
    }, []);


    useEffect(() => {
        const fetchUsage = async () => {
            try {
                const res = await axios.get<UsageData>("/bot/request-usage");
                setUsedRequests(res.data.count);
                const plan = res.data.plan || "";
                setSubscriptionPlan(plan);

                if (!plan || plan === "Free") {
                    setTotalChats(0);
                    setErrorRate(0);
                    setBusiestHour("--");
                    return;
                }
                setTotalChats(res.data.total_chats || 0);
                setErrorRate(res.data.error_rate || 0);
                setBusiestHour(res.data.busiest_hour || "--");
                setIsTrialActive(res.data.is_trial_active || false);
                setTrialEndsInDays(res.data.trial_ends_in_days ?? null);
            } catch (err) {
                console.error("Failed to fetch request usage:", err);
            }
        };
        fetchUsage();
    }, []);

    const renderUpgradeBanner = () => {
        if (subscriptionPlan !== "Basic") return null;
        if (remainingRequests <= 0) {
            return (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    <strong>You've reached your chatbot request limit.</strong> Upgrade to continue using the chatbot.
                </div>
            );
        } else if (remainingRequests <= 10) {
            return (
                <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded mb-4">
                    <strong>You're almost out of chatbot requests!</strong> Upgrade to unlock unlimited access.
                </div>
            );
        }
        return null;
    };

    // Block access if payment is invalid
    if (!isPaymentValid) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-yellow-50 p-6">
                <div className="bg-white p-6 rounded-lg shadow-md text-center max-w-lg">
                    <h2 className="text-2xl font-bold text-yellow-700 mb-3">💳 Payment Required</h2>
                    <p className="text-gray-800 mb-4">
                        Your chatbot access is currently paused because you either don't have an active subscription or we couldn't process your recent payment.
                    </p>
                    <p className="text-gray-600 mb-6">
                        To continue using the platform and serving your customers, please update your billing information.
                    </p>
                    <button
                        onClick={() => navigate("/subscription")}
                        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 font-medium"
                    >
                        🔄 Update Billing Info
                    </button>
                    <p className="text-xs text-gray-500 mt-4">
                        Need help? Contact support or check your payment method.
                    </p>
                </div>
            </div>
        );
    }


    return (
        <div className="min-h-screen p-6 bg-gray-100">
            <div className="max-w-5xl mx-auto space-y-6">
                <h2 className="text-3xl font-bold">👋 Welcome, {restaurant_name}!</h2>
                {/*{paymentWarningShown && (*/}
                {/*    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded shadow mb-4">*/}
                {/*        <p className="font-semibold">⚠️ Payment Failed</p>*/}
                {/*        <p>*/}
                {/*            Your last payment attempt failed. You are still on your previous plan, but please{" "}*/}
                {/*            <span*/}
                {/*                className="underline text-blue-700 cursor-pointer"*/}
                {/*                onClick={() => navigate("/subscription")}*/}
                {/*            >*/}
                {/*                update your billing information*/}
                {/*            </span>{" "}*/}
                {/*            to avoid service disruption.*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*)}*/}

                <p className="text-gray-600">Here’s how your restaurant is performing.</p>

                {renderUpgradeBanner()}

                <div className="bg-white p-6 rounded shadow-md flex justify-between items-center">
                    <div>
                        <h4 className="text-lg font-bold">Your Plan: {subscriptionPlan}</h4>
                        {isTrialActive && trialEndsInDays && trialEndsInDays > 0 && (
                            <p className="text-sm text-blue-600">
                                🎉 You’re on a <strong>free
                                trial</strong>. {trialEndsInDays} day{trialEndsInDays === 1 ? "" : "s"} remaining.
                            </p>
                        )}
                        <p className="text-sm text-gray-600">
                            {subscriptionPlan === "Basic"
                                ? `Limited to ${maxRequests} chatbot requests per month.`
                                : subscriptionPlan === "Pro" || subscriptionPlan === "Enterprise"
                                    ? "Unlimited chatbot access."
                                    : "No active subscription."}
                        </p>
                    </div>
                    {(subscriptionPlan === "Basic" || subscriptionPlan === "Free" || !subscriptionPlan) && (
                        <button
                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow"
                            onClick={() => navigate("/subscription")}
                        >
                            Upgrade Now
                        </button>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-white p-4 rounded shadow text-center">
                        <h4 className="font-bold text-gray-700">🗨️ Total Chats</h4>
                        <p className="text-2xl mt-1">{totalChats}</p>
                    </div>
                    <div className="bg-white p-4 rounded shadow text-center">
                        <h4 className="font-bold text-gray-700">⚠️ Error Rate</h4>
                        <p className="text-2xl mt-1">{errorRate}%</p>
                    </div>
                    <div className="bg-white p-4 rounded shadow text-center">
                        <h4 className="font-bold text-gray-700">🔥 Busiest Hour</h4>
                        <p className="text-2xl mt-1">{busiestHour}</p>
                    </div>
                </div>

                {/*{(subscriptionPlan === "Basic" || subscriptionPlan === "Free" || !subscriptionPlan) && (*/}
                {/*    <div className="bg-white p-6 rounded shadow">*/}
                {/*        <h4 className="text-lg font-bold mb-2">📊 Chatbot Usage</h4>*/}
                {/*        <div className="w-full bg-gray-200 rounded-full h-4 mb-2">*/}
                {/*            <div*/}
                {/*                className="bg-blue-500 h-4 rounded-full transition-all duration-300"*/}
                {/*                style={{ width: `${usagePercent}%` }}*/}
                {/*            ></div>*/}
                {/*        </div>*/}
                {/*        <p className="text-sm text-gray-700">{usedRequests} of {MAX_REQUESTS} requests used</p>*/}
                {/*        <p className="text-sm text-gray-600">{remainingRequests} requests remaining</p>*/}
                {/*    </div>*/}
                {/*)}*/}
                {/*{(subscriptionPlan === "Basic" || subscriptionPlan === "Free" || !subscriptionPlan) && (*/}
                {/*    <div className="bg-white p-6 rounded shadow">*/}
                {/*        <h4 className="text-lg font-bold mb-2">📊 Chatbot Usage</h4>*/}

                {/*        /!* Explanation after trial ends *!/*/}
                {/*        {!isTrialActive && subscriptionPlan === "Basic" && (*/}
                {/*            <p className="text-sm text-blue-600 mb-2">*/}
                {/*                🎉 Your free trial has ended. You now have <strong>100 chatbot requests</strong> on the Basic plan.*/}
                {/*            </p>*/}
                {/*        )}*/}

                {/*        <div className="w-full bg-gray-200 rounded-full h-4 mb-2">*/}
                {/*            <div*/}
                {/*                className="bg-blue-500 h-4 rounded-full transition-all duration-300"*/}
                {/*                style={{ width: `${usagePercent}%` }}*/}
                {/*            ></div>*/}
                {/*        </div>*/}
                {/*        <p className="text-sm text-gray-700">{chatCount} of {MAX_REQUESTS} requests used</p>*/}
                {/*        <p className="text-sm text-gray-600">{remainingRequests} requests remaining</p>*/}
                {/*    </div>*/}
                {/*)}*/}
                {/*{(subscriptionPlan === "Basic" || subscriptionPlan === "Free" || !subscriptionPlan) && (*/}
                {/*    <div className="bg-white p-6 rounded shadow">*/}
                {/*        <h4 className="text-lg font-bold mb-2">📊 Chatbot Usage</h4>*/}

                {/*        /!* Explanation after trial ends *!/*/}
                {/*        {!isTrialActive && subscriptionPlan === "Basic" && (*/}
                {/*            <p className="text-sm text-blue-600 mb-2">*/}
                {/*                🎉 Your free trial has ended. You now have <strong>300 chatbot requests per month</strong> on the Basic plan.*/}
                {/*            </p>*/}
                {/*        )}*/}

                {/*        <div className="w-full bg-gray-200 rounded-full h-4 mb-2">*/}
                {/*            <div*/}
                {/*                className="bg-blue-500 h-4 rounded-full transition-all duration-300"*/}
                {/*                style={{ width: `${usagePercent}%` }}*/}
                {/*            ></div>*/}
                {/*        </div>*/}
                {/*        <p className="text-sm text-gray-700">{chatCount} of {MAX_REQUESTS} requests used</p>*/}
                {/*        <p className="text-sm text-gray-600">{remainingRequests} requests remaining</p>*/}
                {/*    </div>*/}
                {/*)}*/}
                {(subscriptionPlan === "Basic" || subscriptionPlan === "Free" || !subscriptionPlan) && (
                    <div className="bg-white p-6 rounded shadow">
                        <h4 className="text-lg font-bold mb-2">📊 Chatbot Usage</h4>

                        {/* Explanation after trial ends */}
                        {!isTrialActive && subscriptionPlan === "Basic" && (
                            <p className="text-sm text-blue-600 mb-2">
                                🎉 Your free trial has ended. You now have <strong>{maxRequests} chatbot requests per month</strong> on the Basic plan.
                            </p>
                        )}

                        <div className="w-full bg-gray-200 rounded-full h-4 mb-2">
                            <div
                                className="bg-blue-500 h-4 rounded-full transition-all duration-300"
                                style={{ width: `${usagePercent}%` }}
                            ></div>
                        </div>
                        <p className="text-sm text-gray-700">{chatCount} of {maxRequests} requests used</p>
                        <p className="text-sm text-gray-600">{remainingRequests} requests remaining</p>
                    </div>
                )}


                <div className="bg-white p-6 rounded shadow">
                    <h4 className="text-lg font-bold mb-4">✨ What’s Next?</h4>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700 animate-fade-in">
                        {/* Always show menu setup */}
                        <li className="flex items-start gap-2 group">
                            <span title="Manage food items shown to customers" className="text-blue-600">📜</span>
                            <a
                                className="hover:underline"
                                href="/menus"
                                onClick={() => console.log("Menu clicked")}
                            >
                                Add or update your restaurant menu
                            </a>
                        </li>

                        {(subscriptionPlan === "Pro" || subscriptionPlan === "Enterprise") && (
                            <li className="flex items-start gap-2 group">
                                <span title="Set fonts, colors and button styles" className="text-purple-600">🎨</span>
                                <a
                                    className="hover:underline"
                                    href="/theme-setup"
                                    onClick={() => console.log("Theme setup clicked")}
                                >
                                    Customize your chatbot appearance
                                </a>
                            </li>
                        )}

                        {subscriptionPlan === "Enterprise" && (
                            <li className="flex items-start gap-2 group">
                                <span title="See when and how people use your chatbot"
                                      className="text-pink-600">📊</span>
                                <a
                                    className="hover:underline"
                                    href="/analytics"
                                    onClick={() => console.log("Analytics clicked")}
                                >
                                    Explore chatbot analytics and trends
                                </a>
                            </li>
                        )}

                        {subscriptionPlan && (
                            <li className="flex items-start gap-2 group">
                                <span title="Place the chatbot on your website" className="text-green-600">💬</span>
                                <a
                                    className="hover:underline"
                                    href="/chatbot-embed"
                                    onClick={() => console.log("Embed clicked")}
                                >
                                    Embed the chatbot on your website
                                </a>
                            </li>
                        )}

                        {(subscriptionPlan === "Basic" || !subscriptionPlan) && (
                            <li className="flex items-start gap-2 group">
                                <span title="Remove limits and unlock full features"
                                      className="text-red-500 animate-bounce">🚀</span>
                                <a
                                    className="hover:underline font-medium"
                                    href="/subscription"
                                    onClick={() => console.log("Upgrade clicked")}
                                >
                                    Upgrade your plan to unlock premium features
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
}
